import axios from 'axios';
import { CheckForm } from 'components/CheckForm/CheckForm';
import { Input } from 'components/Input/Input';
import { Link } from 'components/Link/Link';
import { Button } from 'components/buttons/Button/Button';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectBlogPage } from 'store/slices/BlogSlice';
import { selectTranslations } from 'store/slices/GeneralTranslationsSlice';
import config from 'api/urls-config.json';

const status_success = 'success';
// TODO not done
const SubscribeCard = () => {
    const { subscribe_title, subscribe_description, subscribe_policy_text } = useSelector(selectBlogPage);
    const { cta_field_email_placeholder } = useSelector(selectTranslations);
    const [email, setEmail] = React.useState('');
    const [status, setStatus] = React.useState('');

    const handleInputChange = e => setEmail(e.target.value);

    const [checked, setChecked] = React.useState(true);
    const handleChange = e => {
        setChecked(e.target.checked);
    };

    const handleSend = () => {
        console.log(email);
        axios.post(`${config.API + config.subscribe}`, { email }).then(response => {
            console.log(response);
            setStatus(response.data.status);
        });
    };
    // axios.post(`${config.API + config.pages.career}`, { email });

    return (
        <div className="subscribe-card">
            <div className="subscribe-card__label">
                <div className="subscribe-card__label-label">• Stay up to date</div>
                <svg width="287" height="80" viewBox="0 0 287 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M286.069 80V16C286.069 7.16345 278.906 0 270.069 0H0C3.9104 0 7.6853 1.43201 10.6119 4.02554L73.7448 59.9745C76.6714 62.568 80.4463 64 84.3567 64H270.069C278.906 64 286.069 71.1635 286.069 80Z"
                        fill="#ffffff"
                    />
                </svg>
            </div>
            {status === status_success ? (
                <div className="subscribe-card__content">
                    <h2>Thanks for subscribing to our newsletter!</h2>
                    <p className="body1 opacity-80">
                        We're constantly publishing fresh news and research, that will help expand your knowledge of the
                        current challenges in the agricultural industry.
                    </p>
                </div>
            ) : (
                <div className="subscribe-card__content">
                    <h2>{subscribe_title}</h2>
                    <p className="body1 opacity-80">{subscribe_description}</p>
                    <div className="subscribe-form">
                        <div className="subscribe-form__input">
                            <Input
                                type="email"
                                placeholder={cta_field_email_placeholder}
                                name="mail"
                                value={email}
                                onChange={handleInputChange}
                            />
                            {/* <Button type={`send ${!checked ? 'disabled' : ''}`} /> */}
                            <button className={`button send ${!checked ? 'disabled' : ''}`} onClick={handleSend} />
                        </div>
                        <CheckForm onChange={handleChange} checked={checked}>
                            <span dangerouslySetInnerHTML={{ __html: subscribe_policy_text }} />
                        </CheckForm>
                    </div>
                </div>
            )}

            {/* Thanks state */}
            {/* <div className="subscribe-card__content">
                <h2>Thanks for subscribing to our newsletter!</h2>
                <p className="body1 opacity-80">
                    We're constantly publishing fresh news and research, that will help expand your knowledge of the
                    current challenges in the agricultural industry.
                </p>
            </div> */}
        </div>
    );
};

export default SubscribeCard;
